module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "OT",
    attrs: {
      "id": "int"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#int"
    }
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush"
  }, [_vm._v("The apostle Paul’s letters remain enigmatic for New Testament interpreters and for those who preach on them. This book fairly presents major interpretive perspectives on Paul and offers insights into how these perspectives influence the preaching of Paul’s letters and therefore how these perspectives might affect listeners in the pews.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The interpretation of the Letter to the Romans in particular is contested to such an extent that many pastors have become afraid to preach through Romans. If they are lectionary pastors, they may wander into a designated text, but they know they are wading quickly into deep waters. Many pastors wish they had more time to become familiar with Pauline scholarship and to patiently work through more texts in Romans.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("This book provides an accessible sketch of the four major interpretive schools of thought on Paul today: the Reformational (old) perspective, the new perspective, the apocalyptic Paul, and the participationist perspective. Each approach to Paul is written by a leading proponent of that approach. The book then provides three sermons from well-known preachers that illustrate how a particular approach to interpreting Romans might play out in preaching Paul.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In addition to being for pastors, this book is for laypersons who want to know more the interpretive processes on the apostle Paul and Romans in particular, since Paul enjoys unique status in having many lay readers showing interest in academic work on his epistles.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Like the apostle Paul, we hope that your mind will be renewed (Rom. 12:2) by the scholarship and the pastoral sensibilities of this volume.")]), _vm._v(" "), _c('p', {
    staticClass: "RightSb1"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("COT")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("C")]), _vm._v("K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NIGHT AND")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSEPH")]), _vm._v(" B. M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ODICA")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ee3c7f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/introduction.vue
// module id = 72
// module chunks = 0